// extracted by mini-css-extract-plugin
export default {"book":"ListFacilities_book__Fwpnw"};